module.exports = __webpack_public_path__ + "img/gift2.6b53820d.png";